import { controls } from "../../controls";

const rp009 = {
  label: "Interest Product",
  starting: true,
  url: "rp009",
  pageLabel: "Interest Product",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Interest Rate", width: "col-sm-2" }),
    ...controls.floatOnly({ tab: "filter", name: "interest_rate", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Open Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "open_date", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ tab: "filter", label: "Account Number", star: true, width: "col-sm-2" }),
    ...controls.AccountNumber({ tab: "filter", isRequired: true, forceRender: true, beforeLeave: ["createAcNo"], displayData: { descn: "account_number_display", guid: 'account_number_guid', sanction_amount: 'sanction_amount' } }),
    ...controls.showData({ tab: "filter", data: "account_number_display", name: "account_number_display", isRequired: true, width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Sanction", width: "col-sm-1" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "sanction_amount" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Expiry Date", width: "col-sm-1" }),
    ...controls.magicDate({ tab: "filter", name: "expiry_date", width: "col-sm-2", dateType: "ontype", }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", }),

    ...controls.checkBox({ tab: "filter", label: "OD-Int", name: "od_int", }),
    ...controls.checkBox({ tab: "filter", label: "Expiry Int-Int", name: "expiry_int", }),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Interest Product",
    filterable: true,
    pdfProps: {
      pageSize: "A4",
      pageOrientation: "landscape",
      header: [
        [{ source: 'history', field: 'reportHeader' }, { source: 'fixed', value: 'As on Date' }, { field: 'as_on_date', type: 'date' }, { source: 'fixed', value: ' In ' }, { field: 'currency_convert' }],
        [{ source: 'fixed', value: 'Parent Branch' }, { field: 'branch_code' }, { source: 'fixed', value: '-' }, { field: 'branch_display' }]
      ],
      footer: {}
    },
    defaultsTo: 0,
    textReportProps: {
      header: [[{ source: 'history', field: 'reportHeader' }, { source: 'fixed', value: 'As on Date' }, { field: 'as_on_date', type: 'date' }], [{ source: 'fixed', value: 'Parent Branch' }, { field: 'branch_code' }, { source: 'fixed', value: '-' }, { field: 'branch_display' }]],
      footer: { width80: [{ type: '' }] },
    },
    reportProps: { searchable: true, sortable: true },
    extraRows: {
      fields: ["credit_cash", "credit_transfer", "credit_total", "debit_cash", "debit_transfer", "debit_total"],
      subtotals: {
        by: "ledger_cat",
        displayIn: "gl_name",
        labels: { type: "fixed", fields: [{ val: 1, label: "Balance Sheet Total" }, { val: 2, label: "Profit & Loss Total" }] },
        // otherstat: [{ type: "count", label: "Count" }, { type: "avg", label: "Average", }, { type: "median", label: "Median" }], 
        groupsOnly: false
      },
      grandtotal: { type: "fixed", displayIn: "gl_name", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr",
        columns: [{
          type: "autoinc",
          accessor: "srno",
          width: 30,
          width80: { size: 3 }
        }]
      },
      {
        Header: "GL",
        columns: [
          {
            accessor: "gl_code",
            width: 60,
            width80: { size: 6 },
            width132: {}
            // rwidth:30,
          }
        ]
      },
      {
        Header: "GL Name",
        columns: [{
          accessor: "gl_name",
          width80: { size: 20, wraplines: 2, fieldalign: 'left' },
          width: 300,
          rwidth: "*",
          // type: "sentencecase",
        }]
      },
      {
        Header: "Credit",
        columns: [
          {
            Header: "Vou",
            accessor: "credit_vouchers",
            align: 'right',
            width80: { size: 3 },
            width: 50,
            // rwidth:30
          },
          {
            Header: "Cash",
            accessor: "credit_cash",
            type: "currency",
            width80: { size: 14, nocomma: true }
          },
          {
            Header: "Transfer",
            accessor: "credit_transfer",
            type: "currency",
            width80: { size: 14, nocomma: true }
          },
          // {
          //   Header: "Total",
          //   accessor: "credit_total",
          //   type: "currency",
          //   width80: { size: 0, nocomma: true },
          //   formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'credit_cash' }, { source: 'fixed', field: 'credit_transfer' }], resultVar: 'total' }],
          // }
        ]
      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "Vou",
            accessor: "debit_vouchers",
            align: 'right',
            width: 50,
            width80: { size: 3 }

            // rwidth:30
          },
          {
            Header: "Cash",
            accessor: "debit_cash",
            type: "currency",
            width80: { size: 14, nocomma: true }

          },
          {
            Header: "Transfer",
            accessor: "debit_transfer",
            type: "currency",
            width80: { size: 14, nocomma: true }

          },
          // {
          //   Header: "Total",
          //   accessor: "debit_total",
          //   type: "currency",
          //   width80: { size: 0, nocomma: true },
          //   formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'debit_cash' }, { source: 'fixed', field: 'debit_transfer' }], resultVar: 'total' }],
          // }
        ]
      },
    ]
  }
}
export default rp009;